import {createContext} from 'preact';
import {useContext} from 'preact/hooks';

export const PageContextCtx = createContext(null);

export const usePageContext = () => useContext(PageContextCtx);
